// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  width: 50px;
  height: 50px;
  padding: 12px 8px;
  border-radius: 25px;
  line-height: 1.2;
}
.btn i {
  font-size: 24px;
}
.btn:focus {
  outline: unset;
}
.btnsm {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  line-height: 1.1;
}
.btnsm i {
  font-size: 16px;
}
.btnsm:focus {
  outline: unset;
}
.btnlg {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  line-height: 1.3;
}
.btnlg i {
  font-size: 35px;
}
.btnlg:focus {
  outline: unset;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/CircleButton.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAJA;EAOI,eAAA;AAAJ;AAKA;EACE,cAAA;AAHF;AAMA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAFA;EAQI,eAAA;AAHJ;AAOA;EACE,cAAA;AALF;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAPF;AAEA;EAOI,eAAA;AANJ;AAUA;EACE,cAAA;AARF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.btn {\n  width: 50px;\n  height: 50px;\n  padding: 12px 8px;\n  border-radius: 25px;\n  line-height: 1.2;\n  i {\n    font-size: 24px;\n  }\n\n}\n\n.btn:focus {\n  outline: unset;\n}\n\n.btnsm {\n  width: 30px;\n  height: 30px;\n  padding: 6px 0px;\n  border-radius: 15px;\n  text-align: center;\n  line-height: 1.1;\n  i {\n    font-size: 16px;\n  }\n}\n\n.btnsm:focus {\n  outline: unset;\n}\n\n\n.btnlg {\n  width: 70px;\n  height: 70px;\n  padding: 10px 16px;\n  border-radius: 35px;\n  line-height: 1.3;\n  i {\n    font-size: 35px;\n  }\n}\n\n.btnlg:focus {\n  outline: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
